import type { App } from 'vue'

let appRef: App | null = null
let motionPromise: Promise<void> | null = null
let installed = false

export function setMotionApp(app: App): void {
  appRef = app
}

export async function ensureMotionPlugin(): Promise<void> {
  if (installed) return
  if (!appRef) return
  if (!motionPromise) {
    motionPromise = import('@vueuse/motion').then(({ MotionPlugin }) => {
      if (!appRef || installed) return
      appRef.use(MotionPlugin)
      installed = true
    })
  }
  await motionPromise
}
